<template>
  <div>
    <Header :headerTitle="$t('m.invoiceCompletion.title')" :hasBackBtn="true"></Header>
    <section>
      <b-img
        :src="require('../../assets/img/wancheng.png')"
        slot="aside"
        width="80px"
        height="80px"
      />
      <p>
        <strong>{{$t('m.invoiceCompletion.success')}}</strong>
      </p>
      <button @click="historyInvoicing()">{{$t('m.invoiceCompletion.button')}}</button>
    </section>
  </div>
</template><script>
export default {
  name: "invoicingInfo",
  data() {
    return {};
  },
  methods: {
    //进入开票历史页面
    historyInvoicing: function() {
      // this.$router.push("/historyInvoicing");
      window.history.go(-3);
    }
  }
};
</script>
<style scoped>
section {
  background-color: #f5f5f5;
  margin-bottom: 0px;
  padding-top: 80px;
  height: 500px;
}
section p {
  padding-top: 10px;
}
section button {
  margin-top: 30px;
  border: 0px;
  border-radius: 3px;
  background-color: #0066B1;
  color: #fff;
  line-height: 40px;
  width: 80%;
}
</style>
    